(() => {
  const root = document.querySelector('[data-momelio-your-moments]');
  if (!root) return;
  const status = root.querySelector('[data-ym-status]');
  const grid = root.querySelector('[data-ym-grid]');
  const cardTemplate = root.querySelector('[data-ym-card-template]');
  const songTemplate = root.querySelector('[data-ym-song-template]');
  if (!status || !grid || !cardTemplate || !songTemplate) return;

  const productNames = {
    custom_song: ['S', 'Custom Song', 'Your song'],
    birthday_banner: ['B', 'Celebration Banner', 'Your banner'],
    pregmometer_birth_journey: ['J', 'Baby Journey', 'Baby HQ']
  };
  const stateLabel = (value) => ({
    provisioning: 'Your Moment is being prepared.',
    lyrics_ready_for_customer_approval: 'Your lyrics are ready to review.',
    active: 'Your Moment is active.',
    delivered: 'Your Moment is ready.',
    completed: 'Your Moment is ready.'
  }[value] || 'Your private Moment is available.');
  const formatTime = (seconds) => {
    const safe = Number.isFinite(seconds) && seconds >= 0 ? Math.floor(seconds) : 0;
    return `${Math.floor(safe / 60)}:${String(safe % 60).padStart(2, '0')}`;
  };
  const postJson = async (url, body) => {
    const response = await fetch(url, {
      method: 'POST', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.message || 'Please try again.');
    return data;
  };
  const setRowStatus = (row, message, isError = false) => {
    const output = row.querySelector('[data-ym-song-status]');
    output.textContent = message || '';
    output.hidden = !message;
    output.classList.toggle('is-error', Boolean(isError));
  };

  const createSongRow = (item, song) => {
    const row = songTemplate.content.firstElementChild.cloneNode(true);
    const audio = row.querySelector('[data-ym-audio]');
    const play = row.querySelector('[data-ym-play]');
    const progress = row.querySelector('[data-ym-progress]');
    const time = row.querySelector('[data-ym-time]');
    const title = String(song.short_label || song.title || 'Your Moment in Music').trim();
    row.querySelector('[data-ym-song-title]').textContent = title;
    audio.src = song.play_url;
    const setPlaying = (playing) => {
      play.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
      play.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} ${title}`);
      row.classList.toggle('is-playing', playing);
    };
    play.addEventListener('click', async () => {
      if (!audio.paused) return audio.pause();
      root.querySelectorAll('[data-ym-audio]').forEach((other) => { if (other !== audio) other.pause(); });
      try { await audio.play(); }
      catch (_) { setRowStatus(row, 'This song could not start. Please refresh and try again.', true); }
    });
    audio.addEventListener('play', () => setPlaying(true));
    audio.addEventListener('pause', () => setPlaying(false));
    audio.addEventListener('ended', () => setPlaying(false));
    audio.addEventListener('loadedmetadata', () => { time.textContent = `0:00 / ${formatTime(audio.duration)}`; });
    audio.addEventListener('timeupdate', () => {
      const duration = Number.isFinite(audio.duration) ? audio.duration : 0;
      progress.value = duration ? String((audio.currentTime / duration) * 100) : '0';
      time.textContent = `${formatTime(audio.currentTime)} / ${formatTime(duration)}`;
    });
    progress.addEventListener('input', () => {
      if (Number.isFinite(audio.duration) && audio.duration > 0) audio.currentTime = (Number(progress.value) / 100) * audio.duration;
    });
    row.querySelector('[data-ym-share]').addEventListener('click', async (event) => {
      const button = event.currentTarget;
      button.disabled = true;
      setRowStatus(row, 'Preparing a private share link…');
      try {
        const data = await postJson(root.dataset.shareEndpoint, { order_line_id: item.order_line_id });
        if (navigator.share) {
          await navigator.share({ title, text: `Listen to ${title} from Momelio.`, url: data.share_url });
          setRowStatus(row, 'Share link ready.');
        } else if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(data.share_url);
          setRowStatus(row, 'Private share link copied.');
        } else {
          window.prompt('Copy this private share link:', data.share_url);
          setRowStatus(row, 'Private share link ready.');
        }
      } catch (error) {
        if (error && error.name !== 'AbortError') setRowStatus(row, error.message || 'The share link could not be created.', true);
        else setRowStatus(row, '');
      } finally { button.disabled = false; }
    });
    row.querySelector('[data-ym-remove]').addEventListener('click', async (event) => {
      if (!window.confirm(`Remove “${title}” from Your Moments? The original order and song will remain safely saved.`)) return;
      const button = event.currentTarget;
      button.disabled = true;
      setRowStatus(row, 'Removing this version from your library…');
      try {
        await postJson(root.dataset.hideEndpoint, { order_line_id: item.order_line_id, artifact_id: song.artifact_id });
        audio.pause();
        row.remove();
        if (!grid.children.length) {
          grid.hidden = true; status.hidden = false;
          status.textContent = 'No songs are currently shown in Your Moments.';
        }
      } catch (error) {
        setRowStatus(row, error.message || 'This song could not be removed from the view.', true);
        button.disabled = false;
      }
    });
    return row;
  };

  const createMomentCard = (item) => {
    const card = cardTemplate.content.firstElementChild.cloneNode(true);
    const labels = [...(productNames[item.product_key] || ['M', 'Momelio', 'Your Moment'])];
    const displayTitle = String(item.display_title || '').trim();
    labels[2] = displayTitle || labels[2];
    card.querySelector('[data-ym-icon]').textContent = labels[0];
    card.querySelector('[data-ym-type]').textContent = labels[1];
    card.querySelector('[data-ym-title]').textContent = labels[2] + (item.shopify_order_name ? ` · ${item.shopify_order_name}` : '');
    card.querySelector('[data-ym-state]').textContent = stateLabel(item.workspace_state);
    card.querySelector('[data-ym-link]').href = item.my_moment_url;
    return card;
  };

  fetch(root.dataset.libraryEndpoint, { credentials: 'same-origin', cache: 'no-store' })
    .then(async (response) => {
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.message || 'Your Moments could not be loaded.');
      return data;
    })
    .then((data) => {
      const items = Array.isArray(data.items) ? data.items : [];
      if (!items.length) {
        status.textContent = 'No Momelio purchases are connected to this Shopify account yet.';
        return;
      }
      const fragment = document.createDocumentFragment();
      items.forEach((item) => {
        const songs = Array.isArray(item.song_candidates) ? item.song_candidates : [];
        if (item.product_key === 'custom_song' && songs.length) songs.forEach((song) => fragment.appendChild(createSongRow(item, song)));
        else fragment.appendChild(createMomentCard(item));
      });
      grid.replaceChildren(fragment);
      grid.hidden = false;
      status.hidden = true;
    })
    .catch((error) => { status.textContent = error.message || 'Your Moments could not be loaded. Please sign in again and retry.'; });
})();
